// eventBus.ts
import mitt from 'mitt';

// Define event types (optional, helps with TypeScript)
type Events = {
  'alert:success': { message: string };
  'alert:error': { message: string };
  'alert:info': { message: string };
  'auth:login': { message: string };
};

// Create and export the event bus
const eventBus = mitt<Events>();

export default eventBus;
